export const language = {
    value: 'en',
};

const getLanguage = (): string => {
    if (typeof window === 'undefined') {
        return language.value;
    }
    return window.chaynsDeLanguage;
};

export default getLanguage;
